import { Book, Bookmark, BriefcaseBusiness, Bug, ChartNoAxesColumn, ChartPie, CircleUser, Gauge, GitMerge, LayoutDashboard, Luggage, School, Settings, Wrench } from "lucide-react";

// Dashboard Section
export const dashboardSection = [
  {
    icon: (
      // <lord-icon
      //   src="https://cdn.lordicon.com/hqymfzvj.json"
      //   trigger="hover"
      //   state="morph-book"
      //   target="#overview"

      //   style={{ width: "16px", height: "16px" }}
      // ></lord-icon>
      <LayoutDashboard className="w-[16px] h-[16px]" />
    ),
    title: "Overview",
    path: `/dashboard`,
    id: "overview",
    description: "KPIs, Alerts, Scorecards",
  },
  {
    icon: <ChartNoAxesColumn className="w-[16px] h-[16px]" />,
    title: "Notifications & Tasks",
    path: `/notifications-tasks`,
    id: "notifications-tasks",
    description: "Manage notifications and tasks",
  },
  {
    icon: <Settings className="w-[16px] h-[16px]" />,
    title: "Approval Dashboard",
    path: `/approval-dashboard`,
    id: "approval-dashboard",
    description: "Review and approve metrics",
  },
];

// Collate: Data Collection Section
export const collateSection = [
  {
    icon: <Luggage className="w-[16px] h-[16px]" />,
    title: "Data Collection Hub",
    path: `/data-collection-hub`,
    id: "data-collection-hub",
    description: "Centralized data collection",
    hasSubItems: true,
    subItems: [
      {
        title: "GHG Emissions",
        path: `/ghg-emissions`,
        description: "Scope 1, 2, 3 emissions tracking",
        hasSubItems: true,
        subItems: [
          {
            title: "Scope 1 Emissions",
            path: `/ghg-emissions/scope-1`,
            description: "Direct emissions from owned sources",
          },
          {
            title: "Scope 2 Emissions",
            path: `/ghg-emissions/scope-2`,
            description: "Indirect emissions from purchased energy",
          },
          {
            title: "Scope 3 Emissions",
            path: `/ghg-emissions/scope-3`,
            description: "Indirect emissions from value chain",
          },
        ],
      },
      {
        title: "Energy",
        path: `/energy`,
        description: "Energy consumption and efficiency",
        hasSubItems: true,
        subItems: [
          {
            title: "Energy Consumption",
            path: `/energy/consumption`,
            description: "Track energy usage across facilities",
          },
          {
            title: "Renewable Energy",
            path: `/energy/renewable`,
            description: "Renewable energy sources and targets",
          },
          {
            title: "Energy Efficiency",
            path: `/energy/efficiency`,
            description: "Energy efficiency initiatives and savings",
          },
        ],
      },
      {
        title: "Water",
        path: `/water`,
        description: "Water usage and conservation",
        hasSubItems: true,
        subItems: [
          {
            title: "Water Consumption",
            path: `/water/consumption`,
            description: "Track water usage and sources",
          },
          {
            title: "Water Conservation",
            path: `/water/conservation`,
            description: "Water conservation initiatives",
          },
          {
            title: "Water Quality",
            path: `/water/quality`,
            description: "Water quality monitoring and compliance",
          },
        ],
      },
      {
        title: "Waste & Circularity",
        path: `/waste-circularity`,
        description: "Waste management and circular economy",
        hasSubItems: true,
        subItems: [
          {
            title: "Waste Generation",
            path: `/waste-circularity/generation`,
            description: "Track waste generation by type",
          },
          {
            title: "Waste Management",
            path: `/waste-circularity/management`,
            description: "Waste management practices and disposal",
          },
          {
            title: "Circular Economy",
            path: `/waste-circularity/circular-economy`,
            description: "Circular economy initiatives and metrics",
          },
        ],
      },
      {
        title: "Health & Safety",
        path: `/health-safety`,
        description: "Incident tracking and reporting",
        hasSubItems: true,
        subItems: [
          {
            title: "Incident Reporting",
            path: `/health-safety/incidents`,
            description: "Report and track safety incidents",
          },
          {
            title: "Safety Training",
            path: `/health-safety/training`,
            description: "Safety training programs and compliance",
          },
          {
            title: "Risk Management",
            path: `/health-safety/risk-assessment`,
            description: "Health and safety risk assessment and Managements",
          },
        ],
      },
      {
        title: "Human Rights & Labor Practices",
        path: `/human-rights-labor`,
        description: "Labor standards and human rights",
        hasSubItems: true,
        subItems: [
          {
            title: "Labor Standards",
            path: `/human-rights-labor/standards`,
            description: "Labor standards compliance and monitoring",
          },
          {
            title: "Human Rights",
            path: `/human-rights-labor/human-rights`,
            description: "Human rights due diligence and assessment",
          },
          {
            title: "Diversity & Inclusion",
            path: `/human-rights-labor/diversity-inclusion`,
            description: "Diversity and inclusion metrics and programs",
          },
        ],
      },
      {
        title: "Organisational Governance & Assessments",
        path: `/assessments`,
        description: "Internal and external assessments",
        hasSubItems: true,
        subItems: [
          {
            title: "Internal Assessments",
            path: `/assessments/internal`,
            description: "Internal performance assessments",
          },
          {
            title: "Stakeholder Surveys",
            path: `/assessments/stakeholder`,
            description: "Stakeholder feedback and surveys",
          },
          {
            title: "Third-party Audits",
            path: `/assessments/third-party-audits`,
            description: "External audit results and findings",
          },
        ],
      },
    ],
  },
  {
    icon: <Book className="w-[16px] h-[16px]" />,
    title: "ESG Documents",
    path: `/esg-documents`,
    id: "esg-documents",
    description: "Document management",
    hasSubItems: true,
    subItems: [
      {
        title: "Compliance Docs",
        path: `/compliance-docs`,
        description: "Certifications & Code of Conduct",
        hasSubItems: true,
        subItems: [
          {
            title: "Certifications",
            path: `/compliance-docs/certifications`,
            description: "ESG certifications and standards",
          },
          {
            title: "Code of Conduct",
            path: `/compliance-docs/code-of-conduct`,
            description: "Corporate code of conduct",
          },
          {
            title: "Regulatory Compliance",
            path: `/compliance-docs/regulatory`,
            description: "Regulatory compliance documents",
          },
        ],
      },
      {
        title: "Evidences",
        path: `/evidences`,
        description: "Supporting documentation",
        hasSubItems: true,
        subItems: [
          {
            title: "Audit Reports",
            path: `/evidences/audit-reports`,
            description: "Internal and external audit reports",
          },
          {
            title: "Performance Data",
            path: `/evidences/performance-data`,
            description: "ESG performance data and metrics",
          },
          {
            title: "Stakeholder Feedback",
            path: `/evidences/stakeholder-feedback`,
            description: "Stakeholder feedback and surveys",
          },
        ],
      },
    ],
  },
];

// Contextualise: ESG Design & Analytics Section
export const contextualiseSection = [
  {
    icon: <Wrench className="w-[16px] h-[16px]" />,
    title: "ESG Policies & Builder",
    path: `/policies-builder`,
    id: "policies-builder",
    description: "Create and manage ESG policies",
  },
  {
    icon: <School className="w-[16px] h-[16px]" />,
    title: "Standards Mapping",
    path: `/builtin-standards-mapping`,
    id: "standards-mapping",
    description: "EcoVadis, BRSR, GRI, SASB",
  },

  {
    icon: <Bug className="w-[16px] h-[16px]" />,
    title: "Custom Field & Metrics Builder",
    path: `/metrics-builder`,
    id: "custom-fields",
    description: "Build custom metrics and fields",
  },
  {
    icon: <Gauge className="w-[16px] h-[16px]" />,
    title: "Analytics & Dashboards",
    path: `/analytics-dashboards`,
    id: "analytics-dashboards",
    description: "Data visualization and insights",
    hasSubItems: true,
    subItems: [
      {
        title: "Environmental Analytics",
        path: `/analytics-dashboards/environmental`,
        description: "Environmental performance analytics",
        hasSubItems: true,
        subItems: [
          {
            title: "Emissions Trends",
            path: `/analytics-dashboards/environmental/emissions-trends`,
            description: "Emissions analysis and trends",
          },
          {
            title: "Energy Analytics",
            path: `/analytics-dashboards/environmental/energy-analytics`,
            description: "Energy consumption and efficiency trends",
          },
          {
            title: "Water Analytics",
            path: `/analytics-dashboards/environmental/water-analytics`,
            description: "Water usage and conservation analytics",
          },
        ],
      },
      {
        title: "Social Analytics",
        path: `/analytics-dashboards/social`,
        description: "Social performance analytics",
        hasSubItems: true,
        subItems: [
          {
            title: "Diversity & Inclusion Metrics",
            path: `/analytics-dashboards/social/diversity-inclusion`,
            description: "D&I performance tracking",
          },
          {
            title: "Labor Analytics",
            path: `/analytics-dashboards/social/labor-analytics`,
            description: "Labor standards and human rights analytics",
          },
          {
            title: "Community Impact",
            path: `/analytics-dashboards/social/community-impact`,
            description: "Community engagement and impact metrics",
          },
        ],
      },
      {
        title: "Supply Chain Analytics",
        path: `/analytics-dashboards/supply-chain`,
        description: "Supply chain and supplier analytics",
        hasSubItems: true,
        subItems: [
          {
            title: "Supplier ESG Risk Map",
            path: `/analytics-dashboards/supply-chain/supplier-risk-map`,
            description: "Supplier risk assessment",
          },
          {
            title: "Supplier Performance",
            path: `/analytics-dashboards/supply-chain/supplier-performance`,
            description: "Supplier ESG performance tracking",
          },
          {
            title: "Supply Chain Transparency",
            path: `/analytics-dashboards/supply-chain/transparency`,
            description: "Supply chain transparency metrics",
          },
        ],
      },
    ],
  },
  {
    icon:<BriefcaseBusiness className="w-[16px] h-[16px]" /> ,
    title: "Reference Data",
    path: `/reference-data`,
    id: "reference-data",
    description: "Reference data and lookup tables",
    hasSubItems: true,
    subItems: [
      {
        title: "Environmental",
        path: `/reference-data/environmental`,
        description: "Environmental reference data and classifications",
      },
      {
        title: "Financial and Economics",
        path: `/reference-data/financial-economics`,
        description: "Financial and economic reference data",
      },
      {
        title: "Corporate Governance",
        path: `/reference-data/corporate-governance`,
        description: "Corporate governance reference data",
      },
      {
        title: "Social and People",
        path: `/reference-data/social-people`,
        description: "Social and people-related reference data",
      },
    ],
  },
];

// Comply: Actions & Standards Section
export const complySection = [
  {
    icon: <CircleUser className="w-[16px] h-[16px]" />,
    title: "Task Control Tracker",
    path: `/task-control-tracker`,
    id: "task-control-tracker",
    description: "Task management and control tracking",
  },
  {
    icon: <Gauge className="w-[16px] h-[16px]" />,
    title: "ESG Reporting",
    path: `/report`,
    id: "esg-reporting",
    description: "Generate ESG reports",
  },
  { 
    icon: <GitMerge className="w-[16px] h-[16px]" />,
    title: "Assurance Review",
    path: `/audyt-ai`,
    id: "compliance-review",
    description: "HAYA SCREEN - AI-powered review",
  },
  {
    
    icon: <Bookmark className="w-[16px] h-[16px]" />,
    title: "Audit Logs",
    path: `/audit-logs`,
    id: "audit-logs",
    description: "Versioning, Approvals, Change History",
  },
];

// Admin & Settings Section
export const adminSection = [
  {
    icon: <CircleUser className="w-[16px] h-[16px]" />,
    title: "User Roles & Permissions",
    path: `/user-management`,
    id: "user-management",
    description: "User access management",
  },

  {
    icon: <ChartPie className="w-[16px] h-[16px]" />,
    title: "Stakeholder Survey Engine",
    path: `/data-Questionaire`,
    id: "stakeholder-survey",
    description: "Survey creation and management",
  },

  {
    icon: <Settings className="w-[16px] h-[16px]" />,
    title: "Workflow Management",
    path: `/workflow-management`,
    id: "workflow-management",
    description: "Manage approval workflows",
  },
  {
    icon: <Settings className="w-[16px] h-[16px]" />,
    title: "Settings",
    path: `/settings`,
    id: "settings",
    description: "Application settings and configuration",
  },
];

// Legacy navigation lists for backward compatibility
export const firstNavBarList = dashboardSection;
export const secondNavBarList = [...collateSection, ...contextualiseSection];
export const thirdNavbarList = [...complySection, ...adminSection];
